import React from "react";
import { Loader } from "semantic-ui-react";

const LoadingBlock = ({ commonLoading, children, size }) => {
  return commonLoading ? (
    <section className="flex items-center justify-center h-[250px]">
      <Loader
        className="!text-main-color"
        active
        size={"big"}
        inline="centered"
      >
        {/* {children} */}
      </Loader>
    </section>
  ) : (
    children
  );
};

export default LoadingBlock;
